const AssesmentLike = ({ color }: any) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='10' cy='10' r='10' fill='#1485BD' />
      <g opacity='0.7'>
        <path
          d='M8.66699 4.3335V7.00016H4.89366C4.70039 6.99797 4.50895 7.03783 4.33261 7.11697C4.15627 7.19612 3.99925 7.31265 3.87242 7.45851C3.74559 7.60436 3.65199 7.77604 3.5981 7.96166C3.54421 8.14728 3.53132 8.3424 3.56033 8.5335L4.48032 14.5335C4.52854 14.8514 4.69004 15.1412 4.93505 15.3495C5.18007 15.5578 5.49211 15.6705 5.81366 15.6668H13.3337H15.3337C15.6873 15.6668 16.0264 15.5264 16.2765 15.2763C16.5265 15.0263 16.667 14.6871 16.667 14.3335V9.66683C16.667 9.31321 16.5265 8.97407 16.2765 8.72402C16.0264 8.47397 15.6873 8.3335 15.3337 8.3335H13.3337L10.667 2.3335C10.1366 2.3335 9.62785 2.54421 9.25278 2.91928C8.87771 3.29436 8.66699 3.80306 8.66699 4.3335Z'
          fill='white'
          stroke='#262626'
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export default AssesmentLike
